module.exports = __webpack_public_path__ + "static/media/icon9.4d5fe207.svg";